import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-export\"><path d=\"M16 6v2H8c-1.2 0-2 .8-2 2v14c0 1.2.8 2 2 2h8v2H8c-2.2 0-4-1.8-4-4V10c0-2.2 1.8-4 4-4zm6.657 5.343L28.325 17l-5.668 5.657-1.414-1.414 3.252-3.253H9.013v-1.98h15.482l-3.252-3.253z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol